import React from 'react'
import '../App.css'
import Bodyresetpass from './bodyresetpass'
export class Bodyappresetpassbody extends React.Component {
    constructor(props){
        super (props)
    }
    render() {       
        return (
            <div className='sshbodyapp'>
                <div className='sshbodyappContainer'>
                    <Bodyresetpass/>
                </div>
            </div>
        );
    }
}